import { ScholarshipSort, ScholarshipsResult } from '@common-types';
import { baseService } from '@services/base.service';

import { withUtahBadges } from '@api/stateSpotlight';
import { STATE_INSTITUTION_SCHOLARSHIPS_LIMIT } from '@constants/stateSpotlight';

export const getInstitutionScholarships = async (institutionId: number): Promise<ScholarshipsResult> => {
  const result = await baseService.getAsync<ScholarshipsResult>('/scholarship-cards', {
    params: { institutionId, sort: ScholarshipSort.UTAH, limit: STATE_INSTITUTION_SCHOLARSHIPS_LIMIT },
  });

  return withUtahBadges(result);
};
